import * as React from 'react';
import { connect } from 'react-redux';
import { default as DispatchProps, mapDispatchToProps } from '../../application/core/DispatchProps';
import ApplicationState from '../../application/core/State';
import CustomersRequested from '../../application/admin/events/CustomersRequested';
import './Clients.css';
import Customer from '../../domain/Customer';
import { RouteComponentProps } from 'react-router';
import UserDetails from '../UserDetails';
import { Link } from 'react-router-dom';
import leftChevron from '../img/left-chevron.svg';
import Order from '../../domain/UserOrder';
import TableHeader from '../TableHeader';
import UserOrder from '../order/UserOrder';
import UserEstimation from '../estimations/UserEstimation';
import UserEstimationModel from '../../domain/UserEstimation';
import { getBackend } from '../../application/core/createStore';
import api from '../../application/core/api';
import { AjaxResponse } from 'rxjs/internal/observable/dom/AjaxObservable';

interface MatchParams {
    customerId: string;
}

interface Props extends RouteComponentProps<MatchParams> {}

interface State {
    tabIsActive: boolean;
    customerOrders: Order[];
    customerEstimations: UserEstimationModel[];
}

interface StateProps {
    customers: Customer[];
}

class ClientDetails extends React.PureComponent<Props & StateProps & DispatchProps, State> {
    constructor(props: DispatchProps & StateProps & Props) {
        super(props);
        this.state = {
            tabIsActive: true,
            customerOrders: [],
            customerEstimations: []
        };
    }

    public componentDidMount(): void {
        this.props.dispatch(new CustomersRequested());
        getBackend()
            .get(`${api()}users/${this.props.match.params.customerId}/estimations`)
            .subscribe((ajaxResponse: AjaxResponse) => {
                this.setState({
                    customerEstimations: ajaxResponse.response
                });
            });
        getBackend()
            .get(`${api()}users/${this.props.match.params.customerId}/orders`)
            .subscribe((ajaxResponse: AjaxResponse) => {
                this.setState({
                    customerOrders: ajaxResponse.response
                });
            });
    }

    public render(): JSX.Element {
        const orderHeaders = [
            'Order #',
            'Date of order',
            'Delivery drop',
            'Type',
            'Total',
            'QTY',
            'Status',
            'Order confirmation',
            'Pack list',
            'Pro-forma invoice',
            'Invoice'
        ];
        const estimationsHeaders = ['Estimation #', 'Date of estimation', 'QTY', 'Total', 'Delivery drop'];
        return (
            <div className="clients client-details">
                <div className="card-go-back">
                    <Link to="/admin/customers">
                        <img src={leftChevron} />
                        Customers list
                    </Link>
                </div>
                <UserDetails title="CLIENT DATA" customer={this.getCustomer()} isAdmin={true} />
                <div className="customer-estimation-orders">
                    <div className="customer-estimation-orders-header">
                        <div
                            className={
                                this.state.tabIsActive ? 'customer-estimation-orders-part active' : 'customer-estimation-orders-part'
                            }
                            onClick={this.switchTab}
                        >
                            Orders
                        </div>
                        <div
                            className={
                                !this.state.tabIsActive ? 'customer-estimation-orders-part active' : 'customer-estimation-orders-part'
                            }
                            onClick={this.switchTab}
                        >
                            Estimations
                        </div>
                    </div>
                    {this.state.tabIsActive ? (
                        <div className="customer-table">
                            <TableHeader headers={orderHeaders} class="customer-table-header" />
                            {this.state.customerOrders.map(order => (
                                <UserOrder
                                    userOrder={order}
                                    customerId={this.props.match.params.customerId}
                                    key={order.id}
                                    link={this.orderLink}
                                />
                            ))}
                        </div>
                    ) : (
                        <div className="client-table">
                            <TableHeader headers={estimationsHeaders} class="customer-table-header" />
                            {this.state.customerEstimations.map(estimation => (
                                <UserEstimation
                                    userEstimations={estimation}
                                    customerId={this.props.match.params.customerId}
                                    link={this.estimationLink}
                                />
                            ))}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    private orderLink = (orderId: number): string => `/admin/customers/${this.props.match.params.customerId}/orders/${orderId}`;
    private estimationLink = (estimationId: number): string =>
        `/admin/customers/${this.props.match.params.customerId}/estimations/${estimationId}`;

    private switchTab = (): void => {
        this.setState({ tabIsActive: !this.state.tabIsActive });
    };

    private getCustomer = (): Customer =>
        this.props.customers.filter(customer => customer.customerId === this.props.match.params.customerId)[0];
}

const mapStateToProps = (state: ApplicationState): StateProps => ({
    customers: state.admin.customers
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ClientDetails);



// WEBPACK FOOTER //
// ./src/view/admin/ClientDetails.tsx